/**
 * Empty list means "all" on the API. When the user selected every available
 * option (or React Aria "all"), send [] instead of thousands of ids.
 */
export function normalizeExportFilterIds(
	selectedIds: number[],
	allIds: number[]
): number[] {
	if (selectedIds.length === 0) {
		return [];
	}

	if (allIds.length > 0 && selectedIds.length >= allIds.length) {
		return [];
	}

	return selectedIds;
}
